const { origin, port } = window.location;

const fullOrigin = `${origin}:${port}`;

const getHash = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash += str.charCodeAt(i);
  }
  return hash.toString(16);
};

export const originHash = getHash(fullOrigin);
